import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "2e5f7380-14a5-4dcf-beeb-15f8319a08c3", content: "Number of sources is irrelevant.", options: {} },
  { id: "f7f7fd7f-4bde-40b7-90bf-1ae069b1af2a", content: "Scattering effect is included.", options: {} },
  { id: "9e60db71-f9dd-413a-928e-bf34b07adce2", content: "Specular reflections are included.", options: {} },
  { id: "cb39931f-e27e-4cd3-8444-d94aaf9d488d", content: "Source directivity can be included.", options: {} },
  {
    id: "7eeee820-f403-4e15-a749-b07bdf8df68f",
    content: "If the receiver position or orientation changes<br>everything needs to be recalculated.",
    options: {},
  },
  {
    id: "5db7ba76-0e95-4f51-89c5-30405f656d7e",
    content: "If the source position or orientation changes<br>everything needs to be recalculated.",
    options: {},
  },
  { id: "9aafaa72-99b1-4bf6-8b5f-4297156e5f3d", content: "Receiver directivity can be included.", options: {} },
  { id: "6d4bd5fb-b87d-4a34-9a78-d71bea17ed09", content: "Real-time calculation possible.", options: {} },
];

export const task: Task = {
  id: "e73462b1-6d61-48fb-9498-893263b6056e",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 2,
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "f7f7fd7f-4bde-40b7-90bf-1ae069b1af2a",
    "9e60db71-f9dd-413a-928e-bf34b07adce2",
    "cb39931f-e27e-4cd3-8444-d94aaf9d488d",
    "7eeee820-f403-4e15-a749-b07bdf8df68f",
    "5db7ba76-0e95-4f51-89c5-30405f656d7e",
    "9aafaa72-99b1-4bf6-8b5f-4297156e5f3d",
    "6d4bd5fb-b87d-4a34-9a78-d71bea17ed09",
  ],
};
